export const PERMISSIONS = {
  brands: {
    brand: {
      read: 'brand:read',
      write: 'brand:write',
      delete: 'brand:delete',
    },
    tabs: {
      management: {
        read: 'brand-tab-management:read',
      },
      pricing_and_suppliers: {
        read: 'brand-tab-pricing-and-suppliers:read',
      },
      pricelist: {
        read: 'brand-tab-pricelist:read',
      },
      communicationHub: {
        read: 'brand-tab-communication-hub:read',
      },
      task: {
        read: 'brand-tab-task:read',
      },
      attachment: {
        read: 'brand-tab-attachment:read',
      },
      logs: {
        read: 'brand-tab-logs:read',
      },
    },
    management: {
      read: 'brand-management:read',
      write: 'brand-management:write',
    },
    sales_management: {
      read: 'brand-sales-management:read',
      write: 'brand-sales-management:write',
      delete: 'brand-sales-management:delete',
    },
    pricelist: {
      read: 'brand-pricelist:read',
      write: 'brand-pricelist:write',
      delete: 'brand-pricelist:delete',
    },
    attachment: {
      read: 'brand-attachment:read',
      write: 'brand-attachment:write',
      delete: 'brand-attachment:delete',
    },
    pricing_rules: {
      read: 'brand-pricing-rules:read',
      write: 'brand-pricing-rules:write',
    },
    supplier: {
      read: 'brand-supplier:read',
      write: 'brand-supplier:write',
      delete: 'brand-supplier:delete',
    },
    main_supplier: {
      read: 'brand-main-supplier:read',
      write: 'brand-main-supplier:write',
    },
    logs: {
      read: 'brand-logs:read',
    },
  },
  clients: {
    client: {
      read: 'client:read',
      write: 'client:write',
      delete: 'client:delete',
    },
    tabs: {
      general: {
        read: 'client-tab-general:read',
      },
      management: {
        read: 'client-tab-management:read',
      },
      shipping: {
        read: 'client-tab-shipping:read',
      },
      payments: {
        read: 'client-tab-payments:read',
      },
      communicationHub: {
        read: 'client-tab-communication-hub:read',
      },
      task: {
        read: 'client-tab-task:read',
      },
      logs: {
        read: 'client-tab-logs:read',
      },
    },
    contact_info: {
      read: 'client-contact-info:read',
      write: 'client-contact-info:write',
    },
    contact_person: {
      read: 'client-contact-person:read',
      write: 'client-contact-person:write',
      delete: 'client-contact-person:delete',
    },
    address: {
      read: 'client-address:read',
      write: 'client-address:write',
    },
    management: {
      read: 'client-management:read',
      write: 'client-management:write',
    },
    shipping_address: {
      read: 'client-shipping-address:read',
      write: 'client-shipping-address:write',
      delete: 'client-shipping-address:delete',
    },
    special_shipping_rate: {
      read: 'client-special-shipping-rate:read',
      write: 'client-special-shipping-rate:write',
      delete: 'client-special-shipping-rate:delete',
    },
    payment_general: {
      read: 'client-payment-general:read',
      write: 'client-payment-general:write',
    },
    payment_terms: {
      read: 'client-payment-terms:read',
      write: 'client-payment-terms:write',
    },
    pricing_rules: {
      read: 'client-pricing-rules:read',
      write: 'client-pricing-rules:write',
    },
    payment_special_pricing_rules: {
      read: 'client-special-pricing-rules:read',
      write: 'client-special-pricing-rules:write',
      delete: 'client-special-pricing-rules:delete',
    },
    logs: {
      read: 'client-logs:read',
    },
  },
  countries: {
    country: {
      read: 'country:read',
      write: 'country:write',
      delete: 'country:delete',
    },
    tabs: {
      management: {
        read: 'country-tab-management:read',
      },
      shipping: {
        read: 'country-tab-shipping:read',
      },
      pricing: {
        read: 'country-tab-pricing:read',
      },
      warehouse: {
        read: 'country-tab-warehouse:read',
      },
      task: {
        read: 'country-tab-task:read',
      },
      logs: {
        read: 'country-tab-logs:read',
      },
    },
    pricing_rules: {
      read: 'country-pricing-rules:read',
      write: 'country-pricing-rules:write',
    },
    client_pricing_rules: {
      read: 'country-client-pricing-rules:read',
      write: 'country-client-pricing-rules:write',
      delete: 'country-client-pricing-rules:delete',
    },
    shipping_rate: {
      read: 'country-shipping-rate:read',
      write: 'country-shipping-rate:write',
      delete: 'country-shipping-rate:delete',
    },
    shipping_city_rate: {
      read: 'country-shipping-city-rate:read',
      write: 'country-shipping-city-rate:write',
      delete: 'country-shipping-city-rate:delete',
    },
    management: {
      read: 'country-management:read',
      write: 'country-management:write',
    },
    warehouse: {
      read: 'warehouse:read',
      write: 'warehouse:write',
    },
    logs: {
      read: 'country-logs:read',
    },
  },
  roles: {
    role: {
      read: 'role:read',
      write: 'role:write',
      delete: 'role:delete',
    },
    tabs: {
      permissions: {
        read: 'role-tab-permissions:read',
      },
      logs: {
        read: 'role-tab-logs:read',
      },
    },
    logs: {
      read: 'role-logs:read',
    },
  },
  users: {
    user: {
      read: 'user:read',
      write: 'user:write',
      delete: 'user:delete',
    },
    tabs: {
      account: {
        read: 'user-tab-account:read',
      },
      attachment: {
        read: 'user-tab-attachment:read',
      },
      logs: {
        read: 'user-tab-logs:read',
      },
    },
    attachment: {
      read: 'user-attachment:read',
      write: 'user-attachment:write',
      delete: 'user-attachment:delete',
    },
    account: {
      read: 'user-account:read',
      write: 'user-account:write',
    },
    account_status: {
      write: 'user-status:write',
    },
    reset_password: {
      write: 'user-account-reset-password:write',
    },
    management_logs: {
      read: 'user-management-logs:read',
    },
    action_logs: {
      read: 'user-action-logs:read',
    },
  },
  suppliers: {
    supplier: {
      read: 'supplier:read',
      write: 'supplier:write',
    },
    tabs: {
      general: {
        read: 'supplier-tab-general:read',
      },
      priceList: {
        read: 'supplier-tab-price-list:read',
      },
      pricing: {
        read: 'supplier-tab-pricing:read',
      },
      shipping: {
        read: 'supplier-tab-shipping:read',
      },
      management: {
        read: 'supplier-tab-management:read',
      },
      communicationHub: {
        read: 'supplier-tab-communication-hub:read',
      },
      task: {
        read: 'supplier-tab-task:read',
      },
      attachment: {
        read: 'supplier-tab-attachment:read',
      },
      logs: {
        read: 'supplier-tab-logs:read',
      },
    },
    competitor_suppliers: {
      read: 'supplier-competitor:read',
    },
    contact_person: {
      read: 'supplier-contact-person:read',
      write: 'supplier-contact-person:write',
      delete: 'supplier-contact-person:delete',
    },
    price_list: {
      read: 'supplier-price-list:read',
      write: 'supplier-price-list:write',
      delete: 'supplier-price-list:delete',
    },
    online_shop: {
      read: 'supplier-online-shop:read',
      write: 'supplier-online-shop:write',
      delete: 'supplier-online-shop:delete',
    },
    pricing_rules: {
      read: 'supplier-pricing-rules:read',
      write: 'supplier-pricing-rules:write',
    },
    legal: {
      read: 'supplier-legal:read',
      write: 'supplier-legal:write',
    },
    bank_information: {
      read: 'supplier-bank-info:read',
      write: 'supplier-bank-info:write',
    },
    special_pricing_rules: {
      read: 'supplier-special-pricing-rules:read',
      write: 'supplier-special-pricing-rules:write',
      delete: 'supplier-special-pricing-rules:delete',
    },
    shipping_rate: {
      read: 'supplier-shipping-rate:read',
      write: 'supplier-shipping-rate:write',
      delete: 'supplier-shipping-rate:delete',
    },
    latest_statistics: {
      read: 'supplier-latest-statistics:read',
    },
    management: {
      read: 'supplier-management:read',
      write: 'supplier-management:write',
    },
    attachment: {
      read: 'supplier-attachment:read',
      write: 'supplier-attachment:write',
      delete: 'supplier-attachment:delete',
    },
    logs: {
      read: 'supplier-logs:read',
    },
  },
  tasks: {
    task: {
      read: 'task:read',
      write: 'task:write',
      delete: 'task:delete',
    },
    tabs: {
      general: {
        read: 'task-tab-general:read',
      },
      attachment: {
        read: 'task-tab-attachment:read',
      },
      logs: {
        read: 'task-tab-logs:read',
      },
    },
    attachment: {
      read: 'task-attachment:read',
      write: 'task-attachment:write',
      delete: 'task-attachment:delete',
    },
    logs: {
      read: 'task-logs:read',
    },
  },
  leads: {
    lead: {
      read: 'lead:read',
      write: 'lead:write',
      delete: 'lead:delete',
    },
    assignment: {
      read: 'lead-assignment:read',
      write: 'lead-assignment:write',
    },
    tabs: {
      general: {
        read: 'lead-tab-general:read',
      },
      communicationHub: {
        read: 'lead-tab-communication-hub:read',
      },
      task: {
        read: 'lead-tab-task:read',
      },
      attachment: {
        read: 'lead-tab-attachment:read',
      },
      logs: {
        read: 'lead-tab-logs:read',
      },
    },
    attachment: {
      read: 'lead-attachment:read',
      write: 'lead-attachment:write',
      delete: 'lead-attachment:delete',
    },
    logs: {
      read: 'lead-logs:read',
    },
  },
  notes: {
    note: {
      read: 'note:read',
      write: 'note:write',
    },
    other_note: {
      write: 'other-note:write',
      delete: 'other-note:delete',
    },
  },
  deals: {
    deal: {
      read: 'deal:read',
      write: 'deal:write',
    },
    attachment: {
      read: 'deal-attachment:read',
      write: 'deal-attachment:write',
      delete: 'deal-attachment:delete',
    },
    assignment: {
      read: 'deal-assignment:read',
      write: 'deal-assignment:write',
    },
    logs: {
      read: 'deal-logs:read',
    },
    tabs: {
      purchaseRequest: {
        read: 'deal-tab-purchase-request:read',
      },
      commercialOffers: {
        read: 'deal-tab-commercial-offers:read',
      },
      communicationHub: {
        read: 'deal-tab-communication-hub:read',
      },
      task: {
        read: 'deal-tab-task:read',
      },
      attachment: {
        read: 'deal-tab-attachment:read',
      },
      logs: {
        read: 'deal-tab-logs:read',
      },
    },
    commercialOffers: {
      read: 'deal-commercial-offers:read',
      write: 'deal-commercial-offers:write',
      delete: 'deal-commercial-offers:delete',
    },
  },
  items: {
    item: {
      read: 'item:read',
      write: 'item:write',
      delete: 'item:delete',
    },
    tabs: {
      suppliers: {
        read: 'item-tab-suppliers:read',
      },
      task: {
        read: 'item-tab-task:read',
      },
      attachment: {
        read: 'item-tab-attachment:read',
      },
      logs: {
        read: 'item-tab-logs:read',
      },
    },
    attachment: {
      read: 'item-attachment:read',
      write: 'item-attachment:write',
      delete: 'item-attachment:delete',
    },
    logs: {
      read: 'item-logs:read',
    },
    supplier: {
      read: 'item-supplier:read',
    },
  },
  purchaseRequests: {
    purchaseRequest: {
      read: 'purchase-request:read',
      write: 'purchase-request:write',
      delete: 'purchase-request:delete',
    },
    tabs: {
      general: {
        read: 'purchase-request-tab-general:read',
      },
      supplierOffers: {
        read: 'purchase-request-tab-supplier-offers:read',
      },
      task: {
        read: 'purchase-request-tab-task:read',
      },
      communicationHub: {
        read: 'purchase-request-tab-communication-hub:read',
      },
      attachment: {
        read: 'purchase-request-tab-attachment:read',
      },
      logs: {
        read: 'purchase-request-tab-logs:read',
      },
    },
    supplierOffers: {
      read: 'purchase-request-supplier-offers:read',
      write: 'purchase-request-supplier-offers:write',
      delete: 'purchase-request-supplier-offers:delete',
    },
    attachment: {
      read: 'purchase-request-attachment:read',
      write: 'purchase-request-attachment:write',
      delete: 'purchase-request-attachment:delete',
    },
    logs: {
      read: 'purchase-request-logs:read',
    },
  },
  dashboard: {
    dashboard: {
      read: 'dashboard:read',
    },
    tabs: {
      dashboard: {
        read: 'dashboard-tab-dashboard:read',
      },
      notification: {
        read: 'dashboard-tab-notifications:read',
      },
    },
  },
  orders: {
    order: {
      read: 'order:read',
      write: 'order:write',
      delete: 'order:delete',
    },
    tabs: {
      general: {
        read: 'order-tab-general:read',
      },
      communicationHub: {
        read: 'order-tab-communication-hub:read',
      },
      task: {
        read: 'order-tab-task:read',
      },
      attachment: {
        read: 'order-tab-attachment:read',
      },
      logs: {
        read: 'order-tab-logs:read',
      },
    },
    management: {
      read: 'order-management:read',
      write: 'order-management:write',
    },
    status_change: {
      read: 'order-status-change:read',
      write: 'order-status-change:write',
    },
    attachment: {
      read: 'order-attachment:read',
      write: 'order-attachment:write',
      delete: 'order-attachment:delete',
    },
    logs: {
      read: 'order-logs:read',
    },
  },
  purchaseOrders: {
    purchaseOrder: {
      read: 'purchase-order:read',
      write: 'purchase-order:write',
      delete: 'purchase-order:delete',
    },
    otherBrandUnassign: {
      write: 'other-brand-unassign:write',
    },
    supplierOffer: {
      write: 'purchase-order-supplier-offer:write',
    },
    tabs: {
      general: {
        read: 'purchase-order-tab-general:read',
      },
      communicationHub: {
        read: 'purchase-order-tab-communication-hub:read',
      },
      task: {
        read: 'purchase-order-tab-task:read',
      },
      attachment: {
        read: 'purchase-order-tab-attachment:read',
      },
      logs: {
        read: 'purchase-order-tab-logs:read',
      },
    },
    attachment: {
      read: 'purchase-order-attachment:read',
      write: 'purchase-order-attachment:write',
      delete: 'purchase-order-attachment:delete',
    },
    logs: {
      read: 'purchase-order-logs:read',
    },
  },
  supplierOffers: {
    supplierOffer: {
      read: 'supplier-offer:read',
      write: 'supplier-offer:write',
      delete: 'supplier-offer:delete',
    },
    tabs: {
      general: {
        read: 'purchase-order-tab-general:read',
      },
      communicationHub: {
        read: 'purchase-order-tab-communication-hub:read',
      },
      task: {
        read: 'purchase-order-tab-task:read',
      },
      attachment: {
        read: 'purchase-order-tab-attachment:read',
      },
      logs: {
        read: 'purchase-order-tab-logs:read',
      },
    },
    attachment: {
      read: 'purchase-order-attachment:read',
      write: 'purchase-order-attachment:write',
      delete: 'purchase-order-attachment:delete',
    },
    logs: {
      read: 'purchase-order-logs:read',
    },
  },
};
